/**
 * Dashboard 관련 Query Keys
 *
 * @description
 * Dashboard 관련 query-key들을 관리합니다.
 */
export const dashboardKeys = {
  /** ALL */
  DASHBOARD_ALL: ['dashboard'],

  /** Chart Dashboard 데이터 조회 */
  GET_CHART_DASHBOARD_DATA: () => ['dashboard', 'getChartDashboardData']
};
